<template>
  <div>
    <b-card class="card-custom-class">
      <div class="closemodel">
        <button
          @click="
            $bvModal.hide('bv-write-review');
            reset();
          "
          type="button"
        >
          <span>
            <img src="img/address/close.png" alt />
          </span>
        </button>
      </div>
      <span class="change-location-text">{{ $t("myOrder.writeReview") }}</span>
    </b-card>
    <b-card>
      <div class="p-4">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
          <!-- Order Summary Box -->
          <b-row class="shadow-sm rounded p-3 mb-4 align-items-center bg-white">
            <!-- Image -->
            <b-col cols="2" class="text-center">
              <b-img
                :src="
                  item && item.imageLink
                    ? item.imageLink
                    : 'https://via.placeholder.com/100'
                "
                fluid
                rounded="circle"
                class="product-image"
              />
            </b-col>

            <!-- Order Info -->
            <b-col cols="10">
              <b-row>
                <!-- Left Column -->
                <b-col md="6">
                  <p class="font-14">
                    <strong>Order Id :</strong> {{ orderDetails.orderId }}
                  </p>
                  <p class="font-14">
                    <strong>Order Delivered Date :</strong> 21-05-2025
                  </p>
                </b-col>

                <!-- Right Column -->
                <b-col md="6">
                  <p class="font-14">
                    <strong>Item Name :</strong>
                    {{ item.name }}
                  </p>
                  <p class="font-14">
                    <strong>Delivered By :</strong>
                    {{ orderDetails?.deliveryAgent?.name || "N/A" }}
                  </p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- Rating Heading -->
          <div class="text-center mb-2">
            <h5><strong>How was your delivery?</strong></h5>
            <p class="text-muted">Please enter your rate experience</p>
          </div>

          <!-- Stars Row -->
          <b-row class="justify-content-center mb-3">
            <div class="text-center">
              <div class="star-rating d-flex">
                <b-icon
                  v-for="i in 5"
                  :key="i"
                  :icon="i <= rating ? 'star-fill' : 'star'"
                  variant="warning"
                  font-scale="2"
                  class="mx-1 pointer"
                  @click="rating = i"
                />
              </div>
              <p v-if="ratingText" class="mt-2 mb-0 font-smallfont-">
                {{ ratingText }}
              </p>
            </div>
          </b-row>

          <!-- Comment and Uploads -->
          <b-row class="mb-3">
            <b-col md="5">
              <label class="d-block mb-2 font-weight-bold">Comment</label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('myOrder.Enteryourcomment')"
              >
                <b-form-textarea
                  :placeholder="$t('myOrder.Enteryourcomment')"
                  rows="4"
                  class="w-100"
                  v-model="reviewComment"
                ></b-form-textarea>
                <span class="validate-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>
            <b-col md="7">
              <label class="d-block mb-2 font-weight-bold">
                Add Photos Or Videos (Optional)
              </label>

              <!-- Upload Trigger -->
              <b-row>
                <b-col md="3">
                  <div
                    class="upload-box-main add-box border rounded text-center d-flex flex-column justify-content-center align-items-center mb-2"
                    @click="triggerFileInput"
                  >
                    <b-icon icon="camera" font-scale="1.5" class="mb-2" />
                    <span class="small text-muted">Add photos or Videos</span>
                  </div>
                </b-col>
                <b-col md="9" class="pl-0">
                  <!-- Uploaded Media Preview List -->
                  <div class="media-list-wrapper">
                    <div class="media-scroll d-flex flex-wrap">
                      <div
                        class="upload-box media-item border rounded text-center position-relative m-2"
                        v-for="(item, index) in mediaFiles"
                        :key="'media-' + index"
                      >
                        <!-- Image Preview -->
                        <img
                          v-if="isImage(item)"
                          :src="item.preview"
                          class="img-preview"
                        />
                        <!-- Video Icon -->
                        <!-- <video
                        controls
                        v-else
                        :src="item.preview"
                        class="img-preview"
                      /> -->
                        <b-icon
                          v-else
                          icon="file-earmark-play"
                          font-scale="2"
                          class="text-muted"
                        />

                        <!-- Remove Icon -->
                        <b-icon
                          icon="x-circle-fill"
                          variant="danger"
                          class="remove-icon"
                          @click.stop="removeFile(index, item.url)"
                        />
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <input
                ref="fileInput"
                type="file"
                accept="image/*,video/*"
                multiple
                class="d-none"
                @change="handleFileUpload"
              />
            </b-col>
          </b-row>

          <!-- What went well -->
          <h5 class="font-weight-medium mb-4">What went well?</h5>
          <b-row class="mb-4">
            <b-col
              md="4"
              sm="6"
              cols="12"
              v-for="(item, index) in tags"
              :key="index"
              class="mb-3 pt-0 pb-0"
            >
              <b-form-checkbox
                v-model="selectedTags"
                :value="item"
                button
                button-variant="outline-primary"
                class="pill-button w-100"
                :class="{ active: selectedTags.includes(item) }"
              >
                {{ item }}
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="mt-0">
            <b-col md="12" class="text-center">
              <p style="display: none">{{ invalid }}</p>
              <b-button variant="primary" @click="onClickSubmit" class="px-5">{{
                $t("myOrder.submit")
              }}</b-button>
            </b-col>
          </b-row>
        </ValidationObserver>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";

export default {
  props: {
    orderId: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      rating: 0,
      tags: [
        "On-time delivery",
        "Accurate product",
        "Value for money",
        "Friendly service",
        "Easy tracking",
        "Secure packaging",
        "Quick response",
      ],
      selectedTags: [],
      mediaFiles: [],
      reviewComment: "",
    };
  },
  computed: {
    ...mapState({
      orderList: (state) => state.profile.orderList,
      userInfo: (state) => state.auth.userInfo,
      reviewData: (state) => state.profile.reviewData,
    }),

    orderDetails() {
      return this.orderList.find((item) => item.orderId === this.orderId);
    },
    reviewDetailsData() {
      const reviewList = this.reviewData?.data || [];

      for (const group of reviewList) {
        const rating = group.ratings?.find(
          (r) => String(r.orderId) === String(this.orderId),
        );
        if (rating) return rating;
      }

      return null;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    ratingText() {
      switch (this.rating) {
        case 1:
          return "Very Bad";
        case 2:
          return "Bad";
        case 3:
          return "Average";
        case 4:
          return "Good";
        case 5:
          return "Very Good";
        default:
          return "";
      }
    },
  },
  methods: {
    reset() {
      this.mediaFiles.forEach(
        (f) => f.preview && URL.revokeObjectURL(f.preview),
      );
      Object.assign(this.$data, this.$options.data());
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      const files = Array.from(event.target.files);

      for (const file of files) {
        const isImage = file.type.startsWith("image");
        try {
          const uploaded = await this.$store.dispatch(
            isImage ? "profile/uploadImageFile" : "profile/uploadVideoFile",
            file,
          );

          this.mediaFiles.push({
            file,
            url: isImage ? uploaded?.fileUrl : uploaded?.url.fileUrl,
            type: file.type.startsWith("image") ? "image" : "video",
            preview: URL.createObjectURL(file),
          });
        } catch (err) {
          this.$bvToast.toast(err.message, {
            variant: "danger",
            title: "Upload Failed",
          });
        }
      }
    },
    async removeFile(index, url) {
      try {
        if (url && url.startsWith("http")) {
          await this.$store.dispatch("profile/deleteMedia", url);
        }

        const file = this.mediaFiles[index];
        file.preview && URL.revokeObjectURL(file.preview);
        this.mediaFiles.splice(index, 1);
      } catch (err) {
        this.$bvToast.toast("Failed to delete media", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },
    isImage(file) {
      return (
        file &&
        (file.type?.startsWith("image") ||
          file.url?.match(/\.(jpeg|jpg|png|gif|webp)$/))
      );
    },

    getDeliveryDate() {
      const date =
        this.orderDetails?.shippingDetails?.response?.[0]?.pieceResponses?.[0]
          ?.deliveryDatestamp;
      return this.formatDate(date);
    },
    validateReviewFields() {
      const errors = [];

      if (!this.orderDetails?.orderId) errors.push("Order ID is required.");
      if (!this.item?.name) errors.push("Item Name is required.");
      if (!this.item?.productId) errors.push("Product ID is required.");
      if (!this.item?.provider) errors.push("Partner ID is required.");
      if (this.rating <= 0) errors.push("Rating is required.");
      if (this.mediafiles?.length > 5) {
        errors.push("You can upload a maximum of 5 media files.");
      }
      //   if(this.selectedTags.length === 0) {
      //     errors.push("Please select at least one tag.");
      //   }

      if (errors.length) {
        this.$bvToast.toast(errors.join("\n"), {
          title: "Missing Information",
          variant: "warning",
          solid: true,
        });
        return false;
      }

      return true;
    },
    async onClickSubmit() {
      try {
        if (!this.validateReviewFields()) return;
        const item = this.item;
        if (!item) {
          this.$bvToast.toast("No item found in order.", {
            variant: "warning",
            solid: true,
          });
          return;
        }
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const payload = {
          subjectId: this.item.productId,
          partnerId: this.item.provider,
          itemName: this.item.name,
          ratings: {
            orderId: this.orderDetails?.orderId || "",
            stars: this.rating,
            feedbackComment: this.reviewComment,
            givenBy: {
              name: {
                first: this.userInfo?.name?.first || "First",
                last: this.userInfo?.name?.last || "Last",
              },
              username: this.userInfo?.username || "anonymous",
            },
            media: this.mediaFiles.map((file) => ({
              url: file.url,
              type: file.type, // "image" or "video"
            })),
            text: this.selectedTags,
          },
        };

        if (this.isEdit) {
          const reviewId = this.reviewDetailsData?._id;
          if (reviewId) {
            let payload = {
              reviewStatus: this.reviewDetailsData.reviewStatus,
              orderId: this.reviewDetailsData.orderId || "",
              stars: this.rating,
              feedbackComment: this.reviewComment,
              givenBy: {
                name: {
                  first: this.userInfo?.name?.first || "First",
                  last: this.userInfo?.name?.last || "Last",
                },
                username: this.userInfo?.username || "anonymous",
              },
              media: this.mediaFiles.map((file) => ({
                url: file.url,
                type: file.type, // "image" or "video"
              })),
              text: this.selectedTags,
            };
            await this.$store.dispatch("profile/updateWriteRatingReview", {
              reviewId,
              payload,
            });
          } else {
            this.$bvToast.toast("Review ID not found for update.", {
              variant: "danger",
              solid: true,
            });
            return;
          }
        } else {
          await this.$store.dispatch("profile/writeRatingReview", payload);
        }

        this.$emit("review-submitted", this.isEdit);
        this.reset();
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to submit review.";
        this.$bvToast.toast(message, {
          toaster: "b-toaster-top-center",
          variant: "danger",
          solid: true,
        });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("profile/fetchOrderList");
    if (this.isEdit && this.item?.productId) {
      try {
        await this.$store.dispatch(
          "profile/getReviewData",
          this.item.productId,
        );

        const allReviews = this.$store.state.profile.reviewData?.data || [];

        const productReview = allReviews
          .flatMap((group) => group.ratings)
          .find((r) => r.orderId === this.orderId);

        if (productReview) {
          this.rating = productReview.stars || 0;
          this.reviewComment = productReview.feedbackComment || "";
          this.selectedTags = productReview.text || [];
          this.mediaFiles = (productReview.media || []).map((file) => ({
            url: file.url,
            type: file.type,
            file: null,
            preview: file.url,
          }));
        }
      } catch (err) {
        this.$bvToast.toast("Failed to load review", {
          variant: "danger",
          solid: true,
        });
      }
    }
  },
};
</script>
<style scoped>
.card-custom-class {
  border: none;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-bottom-color: rgba(0, 0, 0, 0.125);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 0.25rem;
}
.closemodel {
  position: absolute;
  top: 15px;
  right: 12px;
}
.change-location-text {
  font-style: normal;
  font-weight: 520;
  font-size: 1.625rem;
  line-height: 24px;
  margin-left: 0;
  margin-top: 8px;
  color: #2e2e2e;
}
.product-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
::v-deep.pill-button .btn {
  width: 100%;
  border-radius: 30px;
  font-weight: 500;
  padding: 8px 16px;
}

.pill-button {
  transition: 0.3s ease;
}

.pill-button.active {
  background-color: #28a745 !important;
  color: white !important;
  border-color: #28a745 !important;
  border-radius: 30px;
}
.upload-box-main {
  font-size: 12px;
  padding: 10px;
  cursor: pointer;
}
.upload-box {
  width: 80px;
  height: 78px;
  background-color: #fafafa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.add-box {
  margin-bottom: 10px;
}

.img-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.media-scroll {
  max-height: 250px;
  overflow-y: auto;
}

.media-item {
  position: relative;
}

.remove-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 1.2rem;
  background: white;
  border-radius: 50%;
  cursor: pointer;
}
</style>
